/**
 * KAN-905: параметры запросов CRM по флагу "Только новые лиды" (useNewLeadsOnly).
 * Доска: lead_period=1 (бэкенд при периоде отбирает по дню первого сообщения клиента).
 * Таблица: event=lead (период по дню появления лида, как drill из "Лидов по дням");
 * явный ?event= из адреса главнее флага. KAN-973: флаг выключен - event не добавляется,
 * бэкенд отдаёт новые лиды и взятые в работу за период (lead_or_taken).
 * Без периода ("Всё время") ничего не добавляется.
 */
import type { CrmRange } from './crmTable';
import type { CrmTableFlags } from './crmTableShortcuts';
import type { CrmPipelineParams } from '@/types/crmPipeline';

export function boardLeadPeriodParams(
  newLeadsOnly: boolean,
  range: CrmRange | null
): Pick<CrmPipelineParams, 'lead_period'> {
  return newLeadsOnly && range ? { lead_period: '1' } : {};
}

/** Признаки таблицы с event=lead; без изменений возвращает тот же объект. */
export function tableNewLeadsFlags(flags: CrmTableFlags, newLeadsOnly: boolean, range: CrmRange | null): CrmTableFlags {
  if (!newLeadsOnly || !range || flags.event) return flags;
  return { ...flags, event: 'lead' };
}
